export default __webpack_public_path__ + "static/media/coin-master.3e7a313d.webp";